import { render, staticRenderFns } from "./brainCardiovascularDetail.vue?vue&type=template&id=29c4e2b8"
import script from "./brainCardiovascularDetail.vue?vue&type=script&lang=js"
export * from "./brainCardiovascularDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29c4e2b8')) {
      api.createRecord('29c4e2b8', component.options)
    } else {
      api.reload('29c4e2b8', component.options)
    }
    module.hot.accept("./brainCardiovascularDetail.vue?vue&type=template&id=29c4e2b8", function () {
      api.rerender('29c4e2b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/bcs/brainCardiovascularDetail.vue"
export default component.exports